export default __webpack_public_path__ + "static/media/legalNameLogo.aae33882.svg";